<template>
  <div class="p-4">
    <AssetsSummaryChart
      :app="app"
      :sheet="sheet"
    />
  </div>
</template>

<script>
import AssetsSummaryChart from '@/app/views/transactions/charts/assets-summary-chart.vue'

export default {
  components: {
    AssetsSummaryChart
  },
  props: ['app', 'sheet', 'transactions']
}
</script>
